import { AttributeColumnEditor, AttributeDetailEditor } from '@leverege/ui-attributes';
import Types from "../../constants/Types.js";
import DeviceGroupImagineGroupName from "../deviceGroup/ImagineGroupName.js";
import DeviceImagineGroupName from "../device/ImagineGroupName.js";
import ImagineGroupNameRenderer from "./ImagineGroupName.js";
import ObjectAttributeColumnModel from "./objectRenderer/ObjectAttributeColumnModel.js";
import ObjectAttributeDetailModel from "./objectRenderer/ObjectAttributeDetailModel.js";
import ObjectAtrributeColumnRenderer from "./objectRenderer/ObjectAttributeColumnRenderer.js";
import ObjectAttributeDetailRenderer from "./objectRenderer/ObjectAttributeDetailRenderer.js";
import Components from "../firmwareApplication/Components.js";
import AppComponentsRenderer from "./AppComponentsRenderer.js";
import FirmwareComponentsRenderer from "./FirmwareComponentsRenderer.js";
import FirmwareComponentTypes from "../deviceType/FirmwareComponentTypes.js";
export default {
  install: molten => {
    molten.addPlugin('AttributeCellRenderer', {
      objectType: Types.deviceGroup,
      attrName: DeviceGroupImagineGroupName.name,
      renderer: ImagineGroupNameRenderer,
      handles: () => true
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: Types.deviceGroup,
      attrName: DeviceGroupImagineGroupName.name,
      renderer: (value, style, object, context) => {
        return ImagineGroupNameRenderer({
          value: value?.[0]
        }, {
          style,
          object
        }, context);
      },
      handles: () => true
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: Types.device,
      attrName: DeviceImagineGroupName.name,
      renderer: ImagineGroupNameRenderer,
      handles: () => true
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: Types.device,
      attrName: DeviceImagineGroupName.name,
      renderer: (value, style, object, context) => {
        return ImagineGroupNameRenderer({
          value: value?.[0]
        }, {
          style,
          object
        }, context);
      },
      handles: () => true
    });
    molten.addPlugin('Model', {
      type: ObjectAttributeColumnModel.TYPE,
      model: ObjectAttributeColumnModel
    });
    molten.addPlugin('ModelEditor', {
      type: ObjectAttributeColumnModel.TYPE,
      editor: AttributeColumnEditor
    });
    molten.addPlugin('ColumnRenderer', {
      type: ObjectAttributeColumnModel.TYPE,
      renderer: ObjectAtrributeColumnRenderer
    });
    molten.addPlugin('Model', {
      type: ObjectAttributeDetailModel.TYPE,
      model: ObjectAttributeDetailModel
    });
    molten.addPlugin('ModelEditor', {
      type: ObjectAttributeDetailModel.TYPE,
      editor: AttributeDetailEditor
    });
    molten.addPlugin('DetailRenderer', {
      type: ObjectAttributeDetailModel.TYPE,
      renderer: ObjectAttributeDetailRenderer
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: Types.firmwareApplication,
      attrName: Components.name,
      renderer: AppComponentsRenderer,
      handles: () => true
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: Types.firmwareApplication,
      attrName: Components.name,
      renderer: (value, style, object, context) => {
        return AppComponentsRenderer({
          value: value?.[0]
        }, {
          style,
          object
        }, context);
      },
      handles: () => true
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: Types.deviceType,
      attrName: FirmwareComponentTypes.name,
      renderer: FirmwareComponentsRenderer,
      handles: () => true
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: Types.deviceType,
      attrName: FirmwareComponentTypes.name,
      renderer: (value, style, object, context) => {
        return FirmwareComponentsRenderer({
          value: value?.[0]
        }, {
          style,
          object
        }, context);
      },
      handles: () => true
    });
  }
};